import React, { useEffect, useState } from 'react';
import { back, chevron_right, expand, gear } from '../../Images/Icons';
import { useNavigate, useParams } from 'react-router-dom';
import { View } from '../../Components';
import { useForm } from "react-hook-form";
import { GetElecticPrice } from '../../Services/StatisticServices';
import { doUpdateElectricPrice } from '../../Services/StatisticServices';
import css from './ElectricityPrice.module.scss';

const ElectricityPriceEditPage = () => {
    const navigation = useNavigate();
    const {register, handleSubmit, setValue, formState: { errors }} = useForm();
    const [price, setPrice] = useState(0);
    const [state, setAllState] = useState({ data: 0 });
    const station_get = localStorage.getItem("station_get");
    const [showPopup, setShowPopup] = useState(false);

    const setState = data => {
        setAllState(prevState => ({ ...prevState, ...data }));
    }

    const onGoback = () => {
        navigation(-1);
    }


    const onPriceChange = (e) => {
        const { name, value } = e.target;
        setState({ [name]: value });

    }
    function getDataPrice(data) {
        GetElecticPrice(data).then((result) => {
            setPrice(result.data.electricity_price)
            setValue('electricity_price', result.data.electricity_price)
        }).catch(({ response }) => {
           console.log('sdd',response)
        });
    }
      
    function onUpdate(data) {
        // console.log(data)   
        if(data.electricity_price == 0 || data.electricity_price == '' || data.electricity_price == null){
            setDefaultPrice()
        }else{
            doUpdateElectricPrice(data, atob(station_get)).then((result) => {
                setShowPopup(true)
            }).catch(({ response }) => {
                console.log(response)
            });
        }
    }
     
    function setDefaultPrice() {
        const data = { electricity_price: 1650 };
        setPrice(1650)
        doUpdateElectricPrice(data,atob(station_get)).then((result) => {
            getDataPrice(atob(station_get))
            setShowPopup(true)
        }).catch(({ response }) => {
            console.log(response)
        });
    }
    
    useEffect(() => {  
        getDataPrice(atob(station_get))    
    },[price])

    

    return (
        <div>
            {showPopup && 
                <>
                    <div className={css.popup_wrap} onClick={() => setShowPopup(false)}>
                        <div className={css.content_popup}>          
                            <i class="fi fi-rr-cross-small" onClick={() => setShowPopup(false)}></i>
                            <img src="/monitoring/assets/success.png" />
                            <b>Successful!</b>
                            <p>The electricity price has just been updated. </p>
                        </div> 
                    </div>
                </>
            }
            <div className="mainHeader" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', }}>
                <div style={{ display: 'flex', margin: '0 20px' }}>
                    <div onClick={onGoback} style={{
                        display: 'flex', justifyContent: 'center', cursor: 'pointer',
                        alignItems: 'center', width: 32, height: 32, background: 'white', borderRadius: 16
                    }}>
                        <img src={back} alt="" style={{ width: 28, height: 28 }} />
                    </div>
                    <div style={{ fontSize: 18, fontWeight: 500, color: 'white', marginLeft: 12 }}>Edit Electricity Price</div>
                </div>
            </div>
            <form onSubmit={handleSubmit(onUpdate)}>
                <div className="page-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: '#F2F5FA', padding: 16 }}>
                    <div style={{ height: 180, background: 'white', borderRadius: 8, padding: 12 }}>
                        <div style={{ fontSize: 18, fontWeight: 500, color: 'black', marginTop: 10 }}>
                            Change Electricity Price
                        </div>
                        <div style={{ height: 64, marginTop: 8 }}>
                            <div style={{ height: 42, padding: 10, border: 'solid 1px #E0E0E0', borderRadius: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ fontSize: 14, fontWeight: 500, color: '#515151' }}>Electricity Price IDR/kWh</div>
                                <div style={{ fontSize: 18, fontWeight: 500, color: '#292929', }}>
                                <input
                                    name="price"
                                    type="text"
                                    onChange={onPriceChange}
                                    style={{ width: 100, textAlign: 'right', fontSize: 16, fontWeight: 500, color: '#292929', border: 'none', outline: 'none' }}
                                    {...register("electricity_price")}
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                        }
                                    }}
                                />
                                </div>
                            </div>

                        </div>
                        <div onClick={setDefaultPrice} style={{
                            width: '100%', height: 48, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#EEFFF9',
                            color: '#006B34', fontSize: 14, fontWeight: 700, cursor: 'pointer'
                        }}>
                            Use Standard Average Electricity Price
                        </div>
                    </div>
                    <div className={css.button_wrap}>
                        <div onClick={onGoback} style={{
                            width: '48%', height: 44, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#FCFFFE', border: 'solid 1px #B0DACC',
                            color: '#292929', fontSize: 16, fontWeight: 700, borderRadius: 8, cursor: 'pointer'
                        }}>
                            Cancel
                        </div>
                        <button style={{
                            width: '48%', height: 44, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#2DFBB5',
                            color: '#292929', fontSize: 16, fontWeight: 700, borderRadius: 8, cursor: 'pointer', border:0
                        }}>
                            Save
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default ElectricityPriceEditPage